import validate from 'validate.js'
import API from 'storefront/utilities/api'

const JS_HOOK_EMAIL_EXISTS_MSG = '[js-hook-order-account-email-exists]'
const JS_HOOK_NEW_CUSTOMER_MSG = '[js-hook-order-account-new-customer]'
const HIDDEN_CLASS = 'u-hidden'

/**
 * Custom validator to check if email exists
 * @param  {String} value | input value
 * @param {Object} options
 * @returns {Promise} returns resolved promise with message
 */
const emailExists = function (value, options, key) {
  return new validate.Promise((resolve) => {
    const formItem = document.querySelector(`[name$='${key}']`)
    const fieldset = formItem.closest('fieldset')
    // const emailMessages = fieldset.querySelector(JS_HOOK_EMAIL_MESSAGES);
    const emailExistsMsg = fieldset.querySelector(JS_HOOK_EMAIL_EXISTS_MSG)
    const newCustomerMsg = fieldset.querySelector(JS_HOOK_NEW_CUSTOMER_MSG)
    // if (!value) resolve();

    function showEmailExistsMsg() {
      emailExistsMsg.classList.remove(HIDDEN_CLASS)
      newCustomerMsg.classList.add(HIDDEN_CLASS)
    }

    function showNewCustomerMsg() {
      newCustomerMsg.classList.remove(HIDDEN_CLASS)
      emailExistsMsg.classList.add(HIDDEN_CLASS)
    }

    function checkEmailExistsSuccess(data) {
      if (data && data.exists) {
        showEmailExistsMsg()
      } else {
        showNewCustomerMsg()
      }
      resolve()
    }

    const params = {
      email: value,
    }

    API.post(options.endpoint, params)
      .then((response) => checkEmailExistsSuccess(response.data))
      .catch(() => resolve())
  })
}
export default emailExists
